import React from 'react';
import { Typography, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';

import Icon from 'sharedComponents/Icon';
import useStyles from './useStyles';

const Title = props => {
  const classes = useStyles();
  const { text, onBack } = props;

  const handleClickPrev = () => {
    const startScreen = 0;
    onBack(startScreen);
  };

  return (
    <div className={classes.container}>
      <IconButton onClick={handleClickPrev} className={classes.iconButton}>
        <Icon name="arrow" />
      </IconButton>
      <Typography variant="h1">{text}</Typography>
    </div>
  );
};

Title.propTypes = {
  text: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Title/Title.js